import { Container } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { ReferAndEarn } from "./ReferAndEarn";
import { AppTitle } from "../../../components/AppTitle";
import { useDocumentTitle } from "../../../hooks/api/useDocumentTitle";

export function ReferAndEarnPage() {
  const { t } = useTranslation();
  useDocumentTitle(t("Refer and earn — Certn"));

  return (
    <Container>
      <AppTitle title={t("Refer and earn")} />
      <ReferAndEarn />
    </Container>
  );
}
